import { UtilsEnum } from '@/utils/UtilsEnum';

export const CENTRAL_REPROCESSAMENTO_TAMANHO_ENUM = UtilsEnum.create({
  PEQUENO: { value: 'PEQUENO', description: 'Pequeno' },
  MEDIO: { value: 'MEDIO', description: 'Médio' },
  GRANDE: { value: 'GRANDE', description: 'Grande' },
});
